__webpack_require__.p = "/quiz/quiz-master-client/";